import useShoppingIdFromUrl from './useShoppingIdFromUrl';
import { useShoppingIdFromContextProvider } from '@/clientState/providers/checkout/contexts/CheckoutStateContext/hooks';

const useShoppingId = (): string | number => {
  const shoppingIdFromContextProvider = useShoppingIdFromContextProvider();
  const shoppingIdFromUrl = useShoppingIdFromUrl();
  return shoppingIdFromContextProvider || shoppingIdFromUrl;
};

export default useShoppingId;
